import { render, staticRenderFns } from "./ReplaceStandardCard.vue?vue&type=template&id=48059ef2&scoped=true"
import script from "./ReplaceStandardCard.vue?vue&type=script&lang=js"
export * from "./ReplaceStandardCard.vue?vue&type=script&lang=js"
import style0 from "./ReplaceStandardCard.vue?vue&type=style&index=0&id=48059ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48059ef2",
  null
  
)

export default component.exports